export const GOOGLE_CALENDAR_API_AUTH_SCOPE =
   'https://www.googleapis.com/auth/calendar'
